import { adminToken } from "@/lib/api";

/**
 * POST + read a server-sent-event stream of {t: "…"} deltas. `onDelta(text, all)` fires per chunk, resolves with the
 * full text when the server sends {done:true}. Rejects on {error} or network failure. Abortable via the returned controller.
 */
export const streamSse = (url, body, onDelta, signal, onMeta) =>
  new Promise((resolve, reject) => {
    (async () => {
      let all = "";
      try {
        const res = await fetch(url, { method: "POST", signal, headers: { "Content-Type": "application/json", Authorization: `Bearer ${adminToken()}` }, body: JSON.stringify(body) });
        if (!res.ok || !res.body) throw new Error(res.status === 401 ? "Du er logga ut – logg inn på nytt" : `Serveren svara ${res.status}`);
        const reader = res.body.getReader();
        const dec = new TextDecoder();
        let buf = "";
        for (;;) {
          const { value, done } = await reader.read();
          if (done) break;
          buf += dec.decode(value, { stream: true });
          const parts = buf.split("\n\n");
          buf = parts.pop();
          for (const p of parts) {
            const line = p.split("\n").find((l) => l.startsWith("data: "));
            if (!line) continue;
            const ev = JSON.parse(line.slice(6));
            if (ev.error) throw new Error(ev.error);
            if (ev.model) onMeta?.(ev);
            if (ev.t) { all += ev.t; onDelta?.(ev.t, all); }
            if (ev.done) { resolve(all); return; }
          }
        }
        resolve(all);
      } catch (e) {
        reject(e);
      }
    })();
  });
